var render, staticRenderFns
import script from "./v2.vue?vue&type=script&lang=jsx"
export * from "./v2.vue?vue&type=script&lang=jsx"
import style0 from "./v2.vue?vue&type=style&index=0&id=00d76346&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports